// context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

   // ✅ Restore from sessionStorage on app load
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    const storedToken = sessionStorage.getItem("authToken");

    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }

    // ✅ Cross-tab sync for login/logout
    const handleStorage = (e) => {
      if (e.key === "crossTabLogin" && e.newValue) {
        const { user: otherUser, token } = JSON.parse(e.newValue);
        sessionStorage.setItem("user", JSON.stringify(otherUser));
        sessionStorage.setItem("authToken", token);
        setUser(otherUser);
      }
      if (e.key === "crossTabLogout") {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("authToken");
        setUser(null);
      }
    };
    window.addEventListener("storage", handleStorage);
    setIsLoading(false);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

 // ✅ Login
const login = (userData) => {
  if (!userData) return;

  // save token
  sessionStorage.setItem("authToken", userData.accessToken);
  sessionStorage.setItem("refreshToken", userData.refreshToken);
  // save only user object
 sessionStorage.setItem("user", JSON.stringify(userData.user));

  setUser(userData.user);
};


  // ✅ Logout
  const logout = async () => {
    try {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("refreshToken");

      // broadcast logout to other tabs
      localStorage.setItem("crossTabLogout", Date.now());

      setUser(null);
      navigate("/login");
      return { success: true };
    } catch (error) {
      console.error("Logout error:", error);
      return { success: false };
    }
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
